export default "__VITE_ASSET__b6e49dc1__"